<div class="admin-documents">
    <div class="admin-documents-header container-fluid page-container">
        <page-header
            [titleText]="this.getBusinessName()"
            [shortBottomPadding]="true"
            backButtonText="Back To Client Management"
            (handleBackButtonClick)="navigateBackToClientManagement()"
        >
        </page-header>
        <lsq-button
            class="watchers-button"
            appearance="secondary"
            [size]="'md'"
            [type]="'button'"
            (buttonClick)="showWatchersModal()"
        >
            <lsq-icon
                class="watchers-button-icon"
                [type]="icons.FaEye"
                [width]="20"
                [height]="18"
            ></lsq-icon>
            <span class="watchers-button-text"> Watchers ({{ watchersCount() }}) </span>
        </lsq-button>
    </div>
    <div class="container-fluid page-container">
        <dr-tab
            [dynamicRouterLink]="dynamicRouterLink"
            [formGroup]="formGroup"
            [viewedBy]="'admin'"
            [schemaType]="'DocumentCenter'"
            [adminMode]="true"
            [companyKey]="companyKey"
        ></dr-tab>
    </div>
</div>
